export const readFile = (file: Blob): Promise<ArrayBuffer> => {
  return new Promise((resolve, reject) => {
    var fr = new FileReader();
    fr.onload = () => {
      resolve(<ArrayBuffer>fr.result);
    };
    fr.readAsArrayBuffer(file);
  });
};
